import { v4 as uuidv4 } from "uuid"

import AdManager from "./ad-manager"
import AmazonHeaderBidding from "./amazon-hb"
import DemandManager from "./demand-manager"
import Script from "./script"
import Viralize from "./viralize"

class Bidder extends Script {
  constructor(settings) {
    super({
      demandManager: {},
      amazonHeaderBidding: {},
      adManager: {},
      viralize: {},
      ...settings,
    })
    this.auctions = {}
    this.auctionsVideo = {}
    this.demandManager = new DemandManager(this.settings.demandManager)
    this.amazonHeaderBidding = new AmazonHeaderBidding(
      this.settings.amazonHeaderBidding
    )
    this.adManager = new AdManager({
      ...this.settings.adManager,
      displayFunction: this.bid.bind(this),
    })
    this.viralize = new Viralize(this.settings.viralize)
  }

  load() {
    this.demandManager.load()
    this.amazonHeaderBidding.load()
    this.adManager.load()

    if (this.viralize.settings.zid) {
      this.bidVideo()
    }

    if (this.viralize.settings.zid && this.viralize.settings.autoreload) {
      let bidder = this
      let reloaded = 0
      window.vpt = window.vpt || {}
      window.vpt.queue = window.vpt.queue || []
      window.vpt.queue.push(function () {
        window.vpt.on(window.vpt.EVENTS.COMPLETE, function (evt) {
          bidder._debugger("bidder", `Viralize: tag ${evt.zid} player removed`)
          if (reloaded < bidder.viralize.settings.autoreload) {
            reloaded += 1
            bidder._debugger("bidder", "Viralize: reloading player")
            bidder.viralize.customParams = "RELOAD=" + reloaded
            bidder.bidVideo()
          }
        })
      })
    }
  }

  refresh() {
    this.adManager.refresh()
    this.demandManager.refresh()
    this.amazonHeaderBidding.refresh()
    this._debugger("bidder", "done refresh()")
  }

  bid(adPositionPairs, slots) {
    let auctionId = uuidv4()
    this.auctions[auctionId] = {
      amazonHeaderBidding: false,
      demandManager: false,
      slots: adPositionPairs.map(({ position }) => position.id),
    }
    this.amazonHeaderBidding.bid(adPositionPairs, (data) =>
      this.progress(auctionId, "amazonHeaderBidding", data)
    )
    this.demandManager.bid(slots, (data) =>
      this.progress(auctionId, "demandManager", data)
    )
  }

  bidVideo() {
    let auctionId = uuidv4()
    this.auctionsVideo[auctionId] = {
      amazonHeaderBiddingVideo: null,
      demandManagerVideo: null,
    }
    this.demandManager.bidVideo((data) =>
      this.progressVideo(auctionId, "demandManagerVideo", data)
    )
    this.amazonHeaderBidding.bidVideo((data) =>
      this.progressVideo(auctionId, "amazonHeaderBiddingVideo", data)
    )
  }

  progress(auctionId, bidder, data) {
    const auction = this.auctions[auctionId]

    auction[bidder] = true

    this._debugger("bidder", "progress: ", auction)

    this.adManager.push(() => {
      this[bidder].setTargeting()
    })

    if (auction.amazonHeaderBidding && auction.demandManager) {
      this.adManager.push(() => {
        const slots = auction.slots.map((slot) => this.adManager.slots[slot])
        this.adManager.service.pubads().refresh(slots)
      })
    }
  }

  progressVideo(auctionId, bidder, data) {
    const auction = this.auctionsVideo[auctionId]
    auction[bidder] = data

    this._debugger("bidder", "progressVideo: ", auction)

    if (
      auction.amazonHeaderBiddingVideo !== null &&
      auction.demandManagerVideo !== null
    ) {
      this._debugger("bidder", "Loading Viralize")
      this.viralize.load(auction)
    }
  }
}

export default Bidder
